import { CSSProperties } from 'react'
import { FeedbackConfigFieldNames } from 'tabs/nlp/components/UserFeedback/types'

export const userFeedbackTableConfig: Record<
  FeedbackConfigFieldNames,
  { maxWidth: string; title: string; styles?: CSSProperties }
> = {
  userQuestion: { maxWidth: '20%', title: 'User Question' },
  botAnswer: { maxWidth: '20%', title: 'Bot Answer' },
  userFeedback: { maxWidth: '17%', title: 'Feedback' },
  type: { maxWidth: '8%', title: 'Type', styles: { margin: 'auto' } },
  solveButton: { maxWidth: '10%', title: 'Solve' },
  createdAt: { maxWidth: '10%', title: 'Created At' },
  removeButton: { maxWidth: '5%', title: '' },
}

export const userFeedbackTableTitles = Object.values(userFeedbackTableConfig).map(({ title, maxWidth, styles }) => ({
  title,
  maxWidth,
  styles,
}))
